import React from 'react'
import { Trans } from '@lingui/macro'

import Loader from '../../../../components/common/loader/Loader'
import PathwayCard from '../../../student-pathways-page/components/PathwayCard'
import CardGrid from '../../../../components/common/card-grid/CardGrid'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { useAssignedPathwaysQuery } from './YourPathways.codegen'
import { LinkOverlay } from 'front-end/src/components'

import './YourPathways.less'

const YourPathways = () => {
  const { data, loading } = useAssignedPathwaysQuery({
    fetchPolicy: 'network-only'
  })

  if (loading) {
    return <Loader />
  }

  const assignedPathways = data?.me.assignedPathways

  if (!assignedPathways || assignedPathways.length === 0) {
    return null
  }

  return (
    <div className="YourPathways">
      <div className="grid-header">
        <h3>
          <Trans>Your pathways</Trans>
        </h3>
        <LinkOverlay to={staticLinks.pathways} className="view-all">
          <Trans>View all</Trans>
        </LinkOverlay>
      </div>

      <div className="YourPathwaysGrid">
        <CardGrid
          cards={assignedPathways
            .filter((pathway) => pathway.currentEnrolment)
            .map((pathway, index) => (
              <PathwayCard
                linkUrl={linkBuilder.pathwayDetail(pathway.id)}
                key={index}
                pathway={pathway}
                progress={pathway.currentEnrolment?.progress}
              />
            ))}
        />
      </div>
    </div>
  )
}

export default YourPathways
